import React from 'react';
import { Paper, Typography, Box, Button, Snackbar, Alert, CircularProgress } from '@mui/material';

const FormContainer = ({ 
  title, 
  children, 
  onSubmit, 
  isSubmitting = false,
  successMessage = null,
  errorMessage = null,
  onCloseSnackbar
}) => {
  return (
    <Paper elevation={2} sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h5" component="h2" gutterBottom>
        {title}
      </Typography>
      
      <Box component="form" onSubmit={onSubmit} noValidate>
        {children}
        
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            sx={{ minWidth: 120 }}
          >
            {isSubmitting ? <CircularProgress size={24} /> : 'Submit'}
          </Button>
        </Box>
      </Box>
      
      {/* Success/Error messages */}
      <Snackbar 
        open={Boolean(successMessage) || Boolean(errorMessage)} 
        autoHideDuration={6000} 
        onClose={onCloseSnackbar}
      >
        {successMessage ? (
          <Alert onClose={onCloseSnackbar} severity="success" sx={{ width: '100%' }}>
            {successMessage}
          </Alert>
        ) : errorMessage ? (
          <Alert onClose={onCloseSnackbar} severity="error" sx={{ width: '100%' }}>
            {errorMessage}
          </Alert>
        ) : null}
      </Snackbar>
    </Paper>
  );
};

export default FormContainer; 